import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { supabase } from './supabase';

export function AdminCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    console.log('AdminCallback: Starting auth callback handling');
    
    // Get the error from URL if any
    const params = new URLSearchParams(window.location.search);
    const errorDescription = params.get('error_description');
    if (errorDescription) {
      console.error('AdminCallback: Error from URL:', errorDescription);
      setError(errorDescription);
      return;
    }

    // Let Supabase handle the auth state, but we need to handle the redirect
    const { data: { subscription } } = supabase.auth.onAuthStateChange((event, session) => {
      console.log('AdminCallback: Auth state changed:', { event, session });
      
      if (session) {
        // Session exists, redirect to the intended destination
        const from = location.state?.from || '/admin-app';
        console.log('AdminCallback: Redirecting to:', from);
        navigate(from, { replace: true });
      } else {
        // No session found, redirect to login
        console.log('AdminCallback: No session, redirecting to /admin-app');
        navigate('/admin-app', { replace: true });
      }
    });

    return () => {
      subscription.unsubscribe();
    };
  }, [navigate, location]);

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100">
        <div className="text-center p-8 bg-white shadow-lg rounded-lg max-w-md">
          <div className="text-red-600 mb-4">Error during sign in</div>
          <div className="text-gray-700 mb-4">{error}</div>
          <button
            onClick={() => navigate('/admin-app', { replace: true })}
            className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
          >
            Try Again
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900 mx-auto mb-4"></div>
        <div className="text-xl text-gray-600">Completing sign in...</div>
      </div>
    </div>
  );
} 